import { SxProps, Theme } from '@mui/material';

export const emailImageSX: SxProps<Theme> = {
	width: 60,
	height: 60,
};
